import React, { useState, useEffect } from 'react';
import { Cookie, X, ShieldCheck } from 'lucide-react';
import { Button } from './Components';
import { cn } from '../../lib/utils';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check local storage to see if consent is already given
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Add a small delay for a smoother entrance
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    // Even if declined, we usually hide it for the session
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className={cn(
        'fixed bottom-4 left-4 right-4 md:left-8 md:right-auto md:bottom-8 z-100',
        'md:max-w-md animate-in slide-in-from-bottom-10 fade-in duration-700',
      )}
    >
      <div className="bg-white/95 backdrop-blur-md border border-emerald-100 p-4 md:p-6 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] relative overflow-hidden">
        {/* Decorative Background Element */}
        <div className="absolute -top-10 -right-10 w-24 h-24 bg-emerald-50 rounded-full blur-2xl z-0 pointer-events-none"></div>

        <div className="relative z-10">
          <div className="flex items-start gap-3 md:gap-4 mb-3">
            <div className="p-2 md:p-3 bg-emerald-100 rounded-xl text-emerald-600 shadow-sm shrink-0">
              <Cookie className="w-5 h-5 md:w-6 md:h-6" />
            </div>
            <div>
              <h3 className="text-base md:text-lg font-bold font-serif text-slate-900">
                Kebijakan Cookies
              </h3>
              <p className="text-slate-500 text-xs md:text-sm leading-relaxed mt-1">
                Kami menggunakan cookies untuk meningkatkan pengalaman pengguna, keamanan sistem,
                dan analisis trafik website Mathla'un Nawakartika.
              </p>
            </div>
          </div>

          <div className="flex gap-3 mt-3 pt-3 border-t border-slate-100">
            <Button
              onClick={handleAccept}
              className="flex-1 bg-emerald-700 hover:bg-emerald-800 text-white font-bold shadow-emerald-200 text-xs md:text-sm h-9 md:h-10"
              size="sm"
            >
              <ShieldCheck className="w-3 h-3 md:w-4 md:h-4 mr-2" /> Terima
            </Button>
            <Button
              onClick={handleDecline}
              variant="outline"
              className="flex-1 border-slate-200 text-slate-600 hover:bg-slate-50 text-xs md:text-sm h-9 md:h-10"
              size="sm"
            >
              Tolak
            </Button>
          </div>
        </div>

        {/* Close X Button (Optional, purely for UX) */}
        <button
          onClick={handleDecline}
          aria-label="Tutup pemberitahuan cookie"
          title="Tutup pemberitahuan cookie"
          className="absolute top-2 right-2 p-2 text-slate-400 hover:text-slate-600 rounded-full hover:bg-slate-100 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
